// Global z-index scale for layering UI elements.
// Higher values appear on top of lower values.
// Only includes z-indexes that affect global stacking order across the app.

export const zIndexes = {
  // Code editor floating panels (find/search). Above the editor content but
  // below dropdowns so file menus can layer over it.
  codeEditorPanel: 1,

  // Popovers and dropdowns
  dropdown: 12,
  contextMenu: 13,
  branchSelectorDropdown: 12,
  branchSelectorActions: 13,

  // Floating panels triggered from menus (above context menus, below navigation)
  keyboardShortcuts: 14,

  // Navigation overlay (should appear above dropdowns)
  navigation: 15,

  // Context menu opened from the nav itself — must sit above the nav flyout
  // overlay (and its header at navigation + 1), which the generic contextMenu
  // layer sits below.
  navContextMenu: 17,

  // Tooltips (should appear above all other elements)
  tooltip: 20,

  // Transparent overlay during drag-to-resize, to prevent iframes from
  // capturing pointer events and stranding the drag in a stuck state.
  dragOverlay: 21,

  // The "roll the credits" easter egg takes over the whole screen.
  credits: 30,
} as const;
